import { useCallback, useState } from 'react';

// Drag-and-drop state for a drop zone. `onFile` receives the dropped File and is responsible for
// its own validation/upload/error handling (mirrors the file-input change handler).
export const useDragAndDrop = (onFile) => {
  const [dragActive, setDragActive] = useState(false);

  const handleDragEnter = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const file = e.dataTransfer.files?.[0];
    if (file) onFile(file);
  }, [onFile]);

  return {
    dragActive,
    dragHandlers: {
      onDragEnter: handleDragEnter,
      onDragLeave: handleDragLeave,
      onDragOver: handleDragEnter,
      onDrop: handleDrop,
    },
  };
};
